/**
 * ImpersonationBanner - Shows active support/view-as sessions.
 * Appears as a sticky banner with session context and an exit button.
 */
import { useAuthStore } from '@lipaflow/shared'
import { XMarkIcon } from '@heroicons/react/24/outline'

export function ImpersonationBanner() {
  const isImpersonating = useAuthStore((s) => s.isImpersonating)
  const tenantName = useAuthStore((s) => s.impersonatedTenantName)
  const targetUserName = useAuthStore((s) => s.impersonatedTargetUserName)
  const sessionType = useAuthStore((s) => s.impersonationSessionType)
  const mode = useAuthStore((s) => s.impersonationMode)
  const stopImpersonation = useAuthStore((s) => s.stopImpersonation)

  if (!isImpersonating) return null

  return (
    <div className="sticky top-0 z-[60] bg-warning-500 text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2 font-inter text-body-sm font-medium">
        <span>{mode === 'view_only' ? 'Read-only View As:' : 'Support Access:'}</span>
        <span className="font-semibold">
          {targetUserName
            ? `${targetUserName} (${tenantName || 'Unknown Tenant'})`
            : tenantName || 'Unknown Tenant'}
        </span>
        {sessionType && (
          <span className="px-2 py-0.5 rounded bg-white/20 text-[11px] uppercase tracking-wide">
            {sessionType.replace('_', ' ')}
          </span>
        )}
      </div>
      <button
        onClick={stopImpersonation}
        className="flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-lg text-body-sm font-medium transition-colors"
      >
        <XMarkIcon className="h-4 w-4" />
        Exit
      </button>
    </div>
  )
}
